import _ from 'lodash';

import de from './de';
import en from './en';
import nl from './nl';
import fr from './fr';
import es from './es';
import fin from './fin';
import pt from './pt';
import swe from './swe';

const translations = {
  de,
  en,
  nl,
  fr,
  es,
  fin,
  pt,
  swe
};

export function translate(langStringKey, langKey, args = {}) {
  const translation = getTranslation(langKey);
  let str = '';

  if (_.isFunction(translation[langStringKey])) {
    str = translation[langStringKey](args);
  } else if (_.isString(translation[langStringKey])) {
    str = translation[langStringKey];
  }

  return _.entries(args).reduce(
    (memo, [key, val]) => memo.replace(`%${key}%`, val),
    str
  );
}

export default function getTranslation(langKey) {
  return translations[langKey];
}



// WEBPACK FOOTER //
// ./src/commons/translations/index.js